import React from "react";
import { LegalLayout, CompanyInfoTable } from "./LegalLayout";
import { COMPANY } from "@/lib/company";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Iletisim() {
  return (
    <LegalLayout title="İletişim ve Firma Bilgileri">
      <p>
        {COMPANY.brand}, {COMPANY.legalName} tarafından işletilmektedir. Aşağıdaki kanallardan
        bize ulaşabilir, hizmetlerimiz ve satış süreçlerimiz hakkında bilgi alabilirsiniz.
      </p>

      <div className="grid sm:grid-cols-3 gap-4">
        <a href={COMPANY.phoneHref} className="rounded-2xl border border-border bg-card p-5 no-underline hover:shadow-md transition-shadow" data-testid="contact-phone">
          <Phone className="w-5 h-5 text-primary mb-2" />
          <p className="text-sm text-muted-foreground">Telefon</p>
          <p className="font-semibold text-foreground">{COMPANY.phone}</p>
        </a>
        <a href={`mailto:${COMPANY.email}`} className="rounded-2xl border border-border bg-card p-5 no-underline hover:shadow-md transition-shadow" data-testid="contact-email">
          <Mail className="w-5 h-5 text-primary mb-2" />
          <p className="text-sm text-muted-foreground">E-posta</p>
          <p className="font-semibold text-foreground break-all">{COMPANY.email}</p>
        </a>
        <div className="rounded-2xl border border-border bg-card p-5" data-testid="contact-address">
          <MapPin className="w-5 h-5 text-primary mb-2" />
          <p className="text-sm text-muted-foreground">Adres</p>
          <p className="font-semibold text-foreground text-sm">{COMPANY.address}</p>
        </div>
      </div>

      <h2>Firma Bilgileri</h2>
      <CompanyInfoTable />

      <p className="text-sm text-muted-foreground">
        Çağrı merkezi ve destek taleplerinizi hafta içi 09:00 - 18:00 saatleri arasında telefon veya
        e-posta yoluyla iletebilirsiniz. E-posta ile gelen talepler en geç 1 iş günü içinde yanıtlanır.
      </p>
    </LegalLayout>
  );
}
